import WeforsysTreeSelect from "@/components/Weforsys-treeSelect";
import topOperation from "@/components/Weforsys-topOperation/index";
import tableOperation from "@/components/Weforsys-tableOperation";
import Pagination from "@/components/Pagination";
import WeforsysTable from "@/components/Weforsys-table";
import UserBox from "@/components/Weforsys-userBox";
import Screenfull from "@/components/Screenfull";
import ColumnSettings from "@/components/ColumnSettings";
import WeforsysQuill from "@/components/WeforsysEditor/quill";
import UserSelect from "@/components/Weforsys-userSelect";
import uploadBtn from "@/components/Weforsys-uploadBtn";
// 代码生成器专供
import WeforsysText from "@/components/Generator/components/WeforsysText";
import WeforsysUploadFz from "@/components/Generator/components/Upload/UploadFz";
import WeforsysUploadImg from "@/components/Generator/components/Upload/UploadImg";
import UploadFzwx from "@/components/Generator/components/Upload/UploadFzwx";
import PopupSelect from "@/components/Generator/components/PopupSelect";
import PopupSelectt from "@/components/Generator/components/PopupSelectt";
import PopupSelecttt from "@/components/Generator/components/PopupSelecttt";
import PopupSelectpost from "@/components/Generator/components/PopupSelectpost";
//全局导出方法
import ExportComponents from "@/components/Generator/components/ExportComponents";
//批次号

import resetting from "@/components/Generator/components/resetting";
import systemUser from "@/components/Generator/components/systemUser";
import supplier from "@/components/Generator/components/supplier";
import PopupSelectpc from "@/components/Generator/components/PopupSelectpc";
import PopupSelectGeneral from "@/components/Generator/components/PopupSelectGeneral";
//工单
import Workorder from "@/components/Generator/components/Workorder";
//订单
import order from "@/components/Generator/components/order";
//订单
import material from "@/components/Generator/components/material";
//供应商
import WeforsysTableDraggable from "@/components/Weforsys-table-draggable";
import WeforsysTableDraggables from "@/components/Weforsys-table-draggables";
import Weforsystabledragg from "@/components/Weforsys-table-dragg";
import Weforsystabledraggs from "@/components/Weforsys-table-draggs";
import suppliers from "@/components/Generator/components/suppliers";
import suppliersList from "@/components/Generator/components/suppliersList";
import suppliersbutt from "@/components/Generator/components/suppliersbutt";
import supplierbutt from "@/components/Generator/components/supplierbutt";
import Houselocation from "@/components/Generator/components/Houselocation";
import showhidebutt from "@/components/Generator/components/showhidebutt";
import Gaugeoutfit from "@/components/Generator/components/Gaugeoutfit";
import Listwidth from "@/components/Generator/components/Listwidth";
import productCode from "@/components/Generator/components/productCode";
import NumRange from "@/components/Generator/components/NumRange";
import ComSelect from "@/components/Generator/components/ComSelect";
import DepSelect from "@/components/Generator/components/DepSelect";
import PosSelect from "@/components/Generator/components/PosSelect";
import DicSelect from "@/components/Generator/components/DicSelect";
import BillRule from "@/components/Generator/components/BillRule";
import WeforsysInputTable from "@/components/Generator/components/InputTable";
import WeforsysAddress from "@/components/Generator/components/Address";
import GroupTitle from "@/components/Generator/components/GroupTitle";
import RelationForm from "@/components/Generator/components/RelationForm";
import RelationFormAttr from "@/components/Generator/components/RelationFormAttr";
import RelationFlow from "@/components/Generator/components/RelationFlow";
import RelationFlowAttr from "@/components/Generator/components/RelationFlowAttr";
import Calculate from "@/components/Generator/components/Calculate";
import MyTable from "@/components/My-table";
import MyDialog from "@/components/My-dialog";
import MyForm from "@/components/My-form";
import MyInput from "@/components/My-input";
export default {
  install: function install(Vue, options) {
    Vue.component("WeforsysTreeSelect", WeforsysTreeSelect);
    Vue.component("UploadFzwx", UploadFzwx);
    Vue.component("topOpts", topOperation);
    Vue.component("tableOpts", tableOperation);
    Vue.component("Pagination", Pagination);
    Vue.component("WeforsysTable", WeforsysTable);
    Vue.component("WeforsysTableDraggable", WeforsysTableDraggable);
    Vue.component("Weforsystabledragg", Weforsystabledragg);
    Vue.component("WeforsysTableDraggables", WeforsysTableDraggables);
    Vue.component("Weforsystabledraggs", Weforsystabledraggs);
    Vue.component("showhidebutt", showhidebutt);
    Vue.component("resetting", resetting);
    Vue.component("Gaugeoutfit", Gaugeoutfit);
    Vue.component("Listwidth", Listwidth);
    Vue.component("suppliersList", suppliersList);
    Vue.component("uploadBtn", uploadBtn);
    Vue.component("UserBox", UserBox);
    Vue.component("WeforsysText", WeforsysText);
    Vue.component("WeforsysUploadFz", WeforsysUploadFz);
    Vue.component("WeforsysUploadImg", WeforsysUploadImg);
    Vue.component("PopupSelect", PopupSelect);
    Vue.component("PopupSelectt", PopupSelectt);
    Vue.component("PopupSelecttt", PopupSelecttt);
    Vue.component("PopupSelectpost", PopupSelectpost);
    Vue.component("PopupSelectpc", PopupSelectpc);
    Vue.component("PopupSelectGeneral", PopupSelectGeneral);
    Vue.component("Workorder", Workorder);
    Vue.component("order", order);
    Vue.component("ExportComponents", ExportComponents);
    Vue.component("suppliers", suppliers);
    Vue.component("supplier", supplier);
    Vue.component("suppliersbutt", suppliersbutt);
    Vue.component("supplierbutt", supplierbutt);
    Vue.component("Houselocation", Houselocation);
    Vue.component("systemUser", systemUser);
    Vue.component("productCode", productCode);
    Vue.component("material", material);
    Vue.component("NumRange", NumRange);
    Vue.component("ComSelect", ComSelect);
    Vue.component("DepSelect", DepSelect);
    Vue.component("PosSelect", PosSelect);
    Vue.component("UserSelect", UserSelect);
    Vue.component("DicSelect", DicSelect);
    Vue.component("BillRule", BillRule);
    Vue.component("WeforsysInputTable", WeforsysInputTable);
    Vue.component("WeforsysAddress", WeforsysAddress);
    Vue.component("GroupTitle", GroupTitle);
    Vue.component("RelationForm", RelationForm);
    Vue.component("RelationFormAttr", RelationFormAttr);
    Vue.component("RelationFlow", RelationFlow);
    Vue.component("RelationFlowAttr", RelationFlowAttr);
    Vue.component("Calculate", Calculate);
    Vue.component("WeforsysQuill", WeforsysQuill);
    Vue.component("Screenfull", Screenfull);
    Vue.component("ColumnSettings", ColumnSettings);
    Vue.component("MyTable", MyTable);
    Vue.component("MyDialog", MyDialog);
    Vue.component("MyForm", MyForm);
    Vue.component("MyInput", MyInput);
  }
};